import { createMuiTheme, createStyles } from '@material-ui/core/styles'

let primaryColor: string
switch (process.env.REACT_APP_NODE_ENV) {
  case 'local':
    primaryColor = process.env.REACT_APP_LOCAL_COLOR
    break
  case 'development':
    primaryColor = process.env.REACT_APP_DEV_COLOR
    break
  case 'base':
    primaryColor = process.env.REACT_APP_BASE_COLOR
    break
  case 'staging':
    primaryColor = process.env.REACT_APP_STAGING_COLOR
    break
  case 'production':
    primaryColor = process.env.REACT_APP_PROD_COLOR
    break
  case 'test':
    primaryColor = process.env.REACT_APP_TEST_COLOR
    break
  default:
    primaryColor = '#757575'
    break
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: primaryColor,
      contrastText: '#fff'
    }
  },
  typography: {
    fontFamily: `'Roboto', 'Hiragino Kaku Gothic', 'ヒラギノ角ゴシック', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', 'Osaka', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica', 'Arial', 'system-ui', 'sans-serif'`,
    button: {
      textTransform: 'none'
    },
    subtitle2: {
      fontWeight: 600
    }
  },
  overrides: {
    MuiTableHead: createStyles({
      root: {
        '& th': {
          fontWeight: 'bold',
          whiteSpace: 'nowrap'
        }
      }
    }),
    MuiButton: {
      root: {
        whiteSpace: 'nowrap',
        padding: '6px 10px',
        minWidth: '54px'
      }
    }
  }
})

export const mainColor = primaryColor
export default theme
